import { ConsultantsListContainer } from "../containers/ConsultantsListContainer";

export const ConsultantsListPage = () => (
    <ConsultantsListContainer/>
)